import mainFooter from "./mainFooter.component";

const mainFooterModule = angular
  .module("app.components.mainFooter", [])
  .component("mainFooter", mainFooter);

export default mainFooterModule;



// WEBPACK FOOTER //
// ./src/components/mainFooter/mainFooter.module.js